import * as React from 'react';
import { SVGProps,FC } from 'react';

const PartnerSummary: FC<SVGProps<SVGSVGElement>> = (props): JSX.Element => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || 22}
      height={props.height || 22}
      viewBox="0 0 24 24"
      fill="none"
      className={`dynamic-icon ${props.className}`}
      {...props}
    >
      <path
        d="M23 10.35V12C23 17.1854 23 19.7782 21.3891 21.3891C19.7782 23 17.1854 23 12 23C6.81455 23 4.22183 23 2.61091 21.3891C1 19.7782 1 17.1854 1 12C1 6.81455 1 4.22183 2.61091 2.61091C4.22183 1 6.81455 1 12 1H13.65"
        stroke="#282C44"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M6.5 14.1998L8.47658 11.8279C9.25983 10.888 9.65145 10.4181 10.1667 10.4181C10.6819 10.4181 11.0735 10.888 11.8568 11.8279L12.1432 12.1717C12.9265 13.1116 13.3181 13.5815 13.8333 13.5815C14.3485 13.5815 14.7402 13.1116 15.5234 12.1717L17.5 9.7998"
        stroke="#282C44"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="19.6999" cy="4.3" r="3.3" stroke="#282C44" strokeWidth="2" />
      <circle cx="19.6999" cy="4.3" r="3.3" stroke="#282C44" strokeWidth="2" />
    </svg>
  );
  
export default PartnerSummary;

